import React from 'react'
import { Link, useLocation } from 'react-router-dom';
import { useSubMenu } from '../../context/SubMenuContext';
import { checkPermission } from '../../helpers/GeneralHelper';
import { useLoginActivityAccess } from '../../hooks/useLoginActivityAccess';
import { useAuth } from '../../context/AuthContext';

let lastMenu = '';

function LeftSideBar() {

    const location = useLocation();

    // let lastPos = location.pathname.indexOf('/', 1);
    // let route = '';
    // if (lastPos == -1) {
    //     route = location.pathname.slice(1);
    //     console.log('route1 ', route);
    // }else if (lastPos == -2) {
    //     route = location.pathname.slice(1, lastPos);
    //     console.log('route 2 ', route);
    
    // }
    // else {
    //     route = location.pathname.slice(1, lastPos);
    //     console.log('route 2 ', route);
    // }
    const pathSegments = location.pathname.split('/').filter(Boolean); // removes empty strings
    const route = pathSegments[pathSegments.length - 1];
    //console.log('route 3', route);

  const { state } = useAuth();
  const user_data = state?.user_data || {};
  const { canView: canViewSessionLogs } = useLoginActivityAccess();

  const { subMenuOpen, setSubMenuOpen } = useSubMenu();
  const handleCurrentMenu = (menuName)=>{
    if (lastMenu == menuName) {
        lastMenu = '';
        setSubMenuOpen('');
        return;
    }

    setSubMenuOpen(menuName);
    lastMenu = menuName;
  }

  const masterRoutes = ['designations', 'skills', 'requirement-status', 'candidate-status', 'interview-status', 'mode-of-works', 'interview-rounds', 'leaving-reason'];
  const reportsRoutes = ['reports', 'client-report'];
  return (
    <aside className="app-sidebar sticky" id="sidebar">

        {/* <!-- Start::main-sidebar-header --> */}
        <div className="main-sidebar-header">
            <Link to="/dashboard" className="header-logo">
                <img src={`${process.env.REACT_APP_BASE_URL}/assets/images/ancile-digital-logo.png`} alt="logo" className="desktop-logo" />
                <img src={`${process.env.REACT_APP_ASSETS_URL}/assets/images/Logo_Ancile_Digital.png`} alt="logo" className="toggle-logo" />
                <img src={`${process.env.REACT_APP_BASE_URL}/assets/images/ancile-digital-logo.png`} alt="logo" className="desktop-dark" />
                <img src={`${process.env.REACT_APP_ASSETS_URL}/assets/images/Logo_Ancile_Digital.png`} alt="logo" className="toggle-dark" />
                <img src={`${process.env.REACT_APP_BASE_URL}/assets/images/ancile-digital-logo.png`} alt="logo" className="desktop-white" />
                <img src={`${process.env.REACT_APP_ASSETS_URL}/assets/images/Logo_Ancile_Digital.png`} alt="logo" className="toggle-white" />
            </Link>
        </div>
        {/*<!-- End::main-sidebar-header --> */}

        {/* <!-- Start::main-sidebar --> */}
        <div className="main-sidebar" id="sidebar-scroll">

            {/* <!-- Start::nav --> */}
            <nav className="main-menu-container nav nav-pills flex-column sub-open">
                <div className="slide-left" id="slide-left">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24"> <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path> </svg>
                </div>
                <ul className="main-menu">
                    {/* <!-- Start::slide__category --> */}
                    <li className="slide__category"><span className="category-name">Main</span></li>
                    {/* <!-- End::slide__category --> */}

                    <li className="slide">
                        <Link to="/dashboard" className={`side-menu__item ${route == 'dashboard' ? 'active' : ''}`} onClick={() => handleCurrentMenu('dashboard')}>
                            <i className="bx bx-home side-menu__icon"></i>
                            <span className="side-menu__label">Dashboard</span>
                        </Link>
                    </li>

                    {/* <!-- Start::slide__category --> */}
                    {/* <li className="slide__category"><span className="category-name">Clients & Projects</span></li> */}
                    {/* <!-- End::slide__category --> */}

                    <li className={`slide ${! checkPermission('clients') && 'd-none'}`}>
                        <Link to="/clients" className={`side-menu__item ${route == 'clients' ? 'active' : ''}`} onClick={() => handleCurrentMenu('clients')}>
                            <i className="bx bx-user-plus side-menu__icon"></i>
                            <span className="side-menu__label">Clients</span>
                        </Link>
                    </li>

                    <li className={`slide ${! checkPermission('contacts') && 'd-none'}`}>
                        <Link to="/contacts" className={`side-menu__item ${route == 'contacts' ? 'active' : ''}`} onClick={() => handleCurrentMenu('contacts')}>
                            <i className="bi bi-person-rolodex side-menu__icon"></i>
                            <span className="side-menu__label">POCs</span>
                        </Link>
                    </li>

                    <li className={`slide ${! checkPermission('requirements') && 'd-none'}`}>
                        <Link to="/requirements" className={`side-menu__item ${route == 'requirements' ? 'active' : ''}`} onClick={() => handleCurrentMenu('requirements')}>
                            <i className="bi bi-card-checklist side-menu__icon"></i>
                            <span className="side-menu__label">Requirements</span>
                        </Link>
                    </li>

                    <li className={`slide ${! checkPermission('candidates') && 'd-none'}`}>
                        <Link to="/candidates" className={`side-menu__item ${route == 'candidates' ? 'active' : ''}`} onClick={() => handleCurrentMenu('candidates')}>
                            <i className="bi bi-people side-menu__icon"></i>
                            <span className="side-menu__label">Candidates</span>
                        </Link>
                    </li>

                    <li className={`slide ${! checkPermission('interviews') && 'd-none'}`}>
                        <Link to="/interviews" className={`side-menu__item ${route == 'interviews' ? 'active' : ''}`} onClick={() => handleCurrentMenu('interviews')}>
                            <i className="bi bi-briefcase side-menu__icon"></i>
                            <span className="side-menu__label">Interviews</span>
                        </Link>
                    </li>

                    <li className={`slide ${! checkPermission('onboards') && 'd-none'}`}>
                        <Link to="/onboards" className={`side-menu__item ${route == 'onboards' ? 'active' : ''}`} onClick={() => handleCurrentMenu('onboards')}>
                            <i className="bi bi-building side-menu__icon"></i>
                            <span className="side-menu__label">Onboards</span>
                        </Link>
                    </li>

                    <li className={`slide ${! checkPermission('offboards') && 'd-none'}`}>
                        <Link to="/offboards" className={`side-menu__item ${route == 'offboards' ? 'active' : ''}`} onClick={() => handleCurrentMenu('offboards')}>
                            <i className="bi bi-card-checklist side-menu__icon"></i>
                            <span className="side-menu__label">Offboards</span>
                        </Link>
                    </li>

                    <li className={`slide ${! checkPermission('resumes') && 'd-none'}`}>
                        <Link to="/resumes" className={`side-menu__item ${route == 'resumes' ? 'active' : ''}`} onClick={() => handleCurrentMenu('resumes')}>
                            <i className="bx bxs-group side-menu__icon"></i>
                            <span className="side-menu__label">Resumes</span>
                        </Link>
                    </li>

                    <li className={`slide ${! checkPermission('meetings') && 'd-none'}`}>
                        <Link to="/meetings" className={`side-menu__item ${route == 'meetings' ? 'active' : ''}`} onClick={() => handleCurrentMenu('meetings')}>
                            <i className="bi bi-calendar-event side-menu__icon"></i>
                            <span className="side-menu__label">Meetings</span>
                        </Link>
                    </li>

                    <li className={`slide has-sub ${subMenuOpen==='users' ? 'open' : subMenuOpen} ${! checkPermission('users') && 'd-none'}`}>
                        <a href="#" onClick={(e) => {e.preventDefault(); handleCurrentMenu('users')}} className={`side-menu__item ${pathSegments[0] === 'users' ? 'active' : ''}`}>
                            <i className="bx bxs-group side-menu__icon"></i>
                            <span className="side-menu__label">Team Members</span>
                            <i className="fe fe-chevron-right side-menu__angle"></i>
                        </a>
                        <ul className="slide-menu child1" style={{ display: `${subMenuOpen === 'users' ? 'block' : 'none'}` }}>
                            <li className="slide side-menu__label1">
                                <a href="#" onClick={(e) => e.preventDefault()}>Team</a>
                            </li>
                            <li className="slide">
                                <Link to="/users" className={`side-menu__item ${location.pathname === '/users' ? 'active' : ''}`}>Members</Link>
                            </li>
                            <li className={`slide ${!canViewSessionLogs ? 'd-none' : ''}`}>
                                <Link to="/users/session-logs" className={`side-menu__item ${location.pathname === '/users/session-logs' ? 'active' : ''}`}>Login activity</Link>
                            </li>
                        </ul>
                    </li>

                    <li className={`slide ${! checkPermission('invoices') && 'd-none'}`}>
                        <Link to="/invoices" className={`side-menu__item ${route == 'invoices' ? 'active' : ''}`} onClick={() => handleCurrentMenu('invoices')}>
                            <i className="bx bxs-group side-menu__icon"></i>
                            <span className="side-menu__label">Invoices</span>
                        </Link>
                    </li>

                    {/* <!-- Start::slide__category --> */}
                    <li className="slide__category"><span className="category-name">Settings</span></li>

                    {/* <!-- End::slide__category --> */}



                    <li className={`slide has-sub ${subMenuOpen==='masters' ? 'open' : subMenuOpen} `}>
                        <a href="#" onClick={(e) => {e.preventDefault(); handleCurrentMenu('masters')}} className={`side-menu__item ${masterRoutes.indexOf(route) != -1 ? 'active' : ''}`}>
                            <i className="bi bi-list side-menu__icon"></i>
                            <span className="side-menu__label">Masters</span>
                            <i className="fe fe-chevron-right side-menu__angle"></i>
                        </a>
                        <ul className="slide-menu child1" style={{ display: `${subMenuOpen === 'masters' ? 'block' : 'none'}` }}>
                            <li className="slide side-menu__label1">
                                <a href="#" onClick={(e) => e.preventDefault()}>Masters</a>
                            </li>
                            <li className={`slide ${! checkPermission('designations') && 'd-none'}`}>
                                <Link to="/designations" className={`side-menu__item ${route == 'designations' ? 'active' : ''}`}>Designations</Link>
                            </li>
                            <li className={`slide ${! checkPermission('skills') && 'd-none'}`}>
                                <Link to="/skills" className={`side-menu__item ${route == 'skills' ? 'active' : ''}`}>Skills</Link>
                            </li>
                            <li className={`slide ${! checkPermission('requirement-status') && 'd-none'}`}>
                                <Link to="/requirement-status" className={`side-menu__item ${route == 'requirement-status' ? 'active' : ''}`}>Requirement Status</Link>
                            </li>
                            <li className={`slide ${! checkPermission('mode-of-works') && 'd-none'}`}>
                                <Link to="/mode-of-works" className={`side-menu__item ${route == 'mode-of-works' ? 'active' : ''}`}>Mode of Works</Link>
                            </li>
                            <li className={`slide ${! checkPermission('candidate-status') && 'd-none'}`}>
                                <Link to="/candidate-status" className={`side-menu__item ${route == 'candidate-status' ? 'active' : ''}`}>Candidate Status</Link>
                            </li>
                            <li className={`slide ${! checkPermission('interview-rounds') && 'd-none'}`}>
                                <Link to="/interview-rounds" className={`side-menu__item ${route == 'interview-rounds' ? 'active' : ''}`}>Interview Rounds</Link>
                            </li>
                            <li className={`slide ${! checkPermission('interview-status') && 'd-none'}`}>
                                <Link to="/interview-status" className={`side-menu__item ${route == 'interview-status' ? 'active' : ''}`}>Interview Status</Link>
                            </li>
                            <li className={`slide ${! checkPermission('leaving-reason') && 'd-none'}`}>
                                <Link to="/leaving-reason" className={`side-menu__item ${route == 'leaving-reason' ? 'active' : ''}`}>Leaving Reasons</Link>
                            </li>
                        </ul>
                    </li>
                    <li className={`slide has-sub ${subMenuOpen==='reports' ? 'open' : subMenuOpen} ${! checkPermission('reports') && 'd-none'}`}>
                        <a href="#" onClick={(e) => {e.preventDefault(); handleCurrentMenu('reports')}} className={`side-menu__item ${reportsRoutes.indexOf(route) != -1 ? 'active' : ''}`}>
                            <i className="bi bi-card-checklist side-menu__icon"></i>
                            <span className="side-menu__label">Reports</span>
                            <i className="fe fe-chevron-right side-menu__angle"></i>
                        </a>
                        <ul className="slide-menu child1" style={{ display: `${subMenuOpen === 'reports' ? 'block' : 'none'}` }}>
                            <li className="slide side-menu__label1">
                                <a href="#" onClick={(e) => e.preventDefault()}>Reports</a>
                            </li>
                            <li className={`slide ${! checkPermission('reports') && 'd-none'}`}>
                                <Link to="/reports/client-report" className={`side-menu__item ${route == 'client-report' ? 'active' : ''}`}>Client Report</Link>
                            </li>
                            <li className={`slide ${! checkPermission('reports') && 'd-none'}`}>
                                <Link to="/reports/monthly-reports" className={`side-menu__item ${route == 'monthly-reports' ? 'active' : ''}`}>Monthly Reports</Link>
                            </li>
                            <li className={`slide ${! checkPermission('reports') && 'd-none'}`}>
                                <Link to="/reports/daily-reports" className={`side-menu__item ${route == 'daily-reports' ? 'active' : ''}`}>Daily Reports</Link>
                            </li>
                        </ul>
                    </li>

                    <li className={`slide ${! checkPermission('user-roles') && 'd-none'}`}>
                        <Link to="/user-roles" className={`side-menu__item ${route == 'user-roles' ? 'active' : ''}`} onClick={() => handleCurrentMenu('user-roles')}>
                            <i className="bx bxs-group side-menu__icon"></i>
                            <span className="side-menu__label">User Roles</span>
                        </Link>
                    </li>
                </ul>
                <div className="slide-right" id="slide-right"><svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24"> <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path> </svg></div>
            </nav>
            {/* <!-- End::nav --> */}

        </div>
        {/* <!-- End::main-sidebar --> */}

    </aside>
  )
}

export default LeftSideBar
